// «Predefinito di PopTown» in cima alla pagina Provider (tela, artboard 43): provider, modello e
// ragionamento che usano i pop e le attività che non ne scelgono uno. Si salva a ogni scelta.
import { useEffect, useState } from 'react';
import { Banner } from '../../components/Banner';
import { ApiError, api } from '../../lib/api';
import type { ConnectedProvider, DefaultChoice } from '../../lib/api';
import { useStore } from '../../store/StoreProvider';
import { ModelPicker, type ModelValue } from '../agents/ModelPicker';

export function DefaultModelCard({ providers }: { providers: ConnectedProvider[] }) {
  const { toast } = useStore();
  const [choice, setChoice] = useState<DefaultChoice | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void api.defaultModel().then(setChoice, () => setError('Non riesco a leggere il predefinito.'));
  }, [providers]);

  const save = (v: ModelValue) => {
    const previous = choice;
    setChoice({ ...v, resolved: v.model });
    setError(null);
    api
      .setDefaultModel(v)
      .then((saved) => {
        setChoice(saved);
        toast({ kind: 'success', title: 'Predefinito salvato' });
      })
      .catch((e: unknown) => {
        setChoice(previous);
        setError(e instanceof ApiError && e.detail ? e.detail : 'Non riesco a salvarlo.');
      });
  };

  if (!choice || providers.length === 0) return null;
  return (
    <div style={{ display: 'grid', gap: 8, marginBottom: 20 }}>
      <ModelPicker
        providers={providers}
        value={{
          model: choice.model ?? choice.resolved ?? null,
          effort: choice.effort,
          thinking: choice.thinking,
        }}
        onChange={save}
        title="Predefinito di PopTown"
        subtitle="Lo usano i pop e le attività che non scelgono un modello."
        hero={{ avatar: 'scheduler-01' }}
      />
      {error && <Banner kind="danger">{error}</Banner>}
    </div>
  );
}
